import { ChatEnum } from '../../../../Chat.enum';
import { useChatContext } from '../../../../Chat.hook';
import { useMessageBarContext } from '../../MessageBar.hook';
import AgendaAction from '../AgendaAction/AgendaAction.component';
import CreateQuickAction from '../CreateQuickAction/CreateQuickAction.component';
import InteractiveAction from '../InteractiveAction/InteractiveAction.component';
import NotesAction from '../NotesAction/NotesAction.component';
import ProgrammedMessageAction from '../ProgrammedMessageAction/ProgrammedMessageAction.component';
import QuickAction from '../QuickActionsAction/QuickAction.component';
import ResendAction from '../ResendAction/ResendAction.component';
import DriveFilesAction from '../ToolActions/components/DriveFilesAction/DriveFilesAction.component';
import DriveFilesActionProvider from '../ToolActions/components/DriveFilesAction/DriveFilesAction.context';
import GoogleMapsAction from '../ToolActions/components/GoogleMapsAction/GoogleMapsAction.component';
import TemplatesActions from '../TemplateActions/TemplateActions.component';
import WabTemplatesAction from '../WabTemplatesAction/WabTemplatesAction.component.tsx';
import WabTemplatesVariablesAction from '../WabTemplatesVariablesAction/WabTemplatesVariablesAction.component.tsx';
import WabTemplateScheduleAction from '../WabTemplateScheduleAction/WabTemplateScheduleAction.component.tsx';
import WapiScheduleSelector from '../WapiScheduleSelector/WapiScheduleSelector.component.tsx';

export function RenderActionComponent() {
  const { selectedAction } = useMessageBarContext();
  const { isResending, setQuickActionState, quickActionState } =
    useChatContext();

  if (isResending) {
    return <ResendAction />;
  }

  switch (selectedAction) {
    case ChatEnum.CHAT:
      return <></>;
    case ChatEnum.PROGRAMMED_MESSAGES:
      return <ProgrammedMessageAction />;
    case ChatEnum.QUICK_ACTIONS:
      return (
        <QuickAction
          setQuickActionState={setQuickActionState}
          quickActionState={quickActionState}
        />
      );
    case ChatEnum.CREATE_QUICK_ACTION:
      return (
        <CreateQuickAction
          setQuickActionState={setQuickActionState}
          quickActionState={quickActionState}
        />
      );
    case ChatEnum.NOTES:
      return <NotesAction />;
    case ChatEnum.EVENTS:
      return <AgendaAction />;
    case ChatEnum.MAPS:
      return <GoogleMapsAction />;
    case ChatEnum.DRIVE:
      return (
        <DriveFilesActionProvider>
          <DriveFilesAction />
        </DriveFilesActionProvider>
      );
    case ChatEnum.TEMPLATES:
      return <TemplatesActions />;
    case ChatEnum.WABTEMPLATES:
      return <WabTemplatesAction />;
    case ChatEnum.WABTEMPLATES_VARIABLES:
      return <WabTemplatesVariablesAction />;
    case ChatEnum.WABTEMPLATES_SCHEDULED:
      return <WabTemplateScheduleAction />;
    case ChatEnum.WAPI_SCHEDULE_SELECTOR:
      return <WapiScheduleSelector />;
    case ChatEnum.INTERACTIVE:
      return <InteractiveAction />;
    default:
      return null;
  }
}
